export const TOGGLE_LOAD_STATE = 'TOGGLE_LOAD_STATE';
export const UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME';